import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/Button';
import { pageInfo } from '@/lib/pagination';

/**
 * Листание списка, который сервер отдаёт страницами (`offset`/`limit`/`total`). Раньше жил только в списке учеников;
 * список курсов показывал первые 20 и не листался вовсе (разбор удобства 28.09, №4).
 */
export function Pagination({
  offset,
  limit,
  total,
  onChange,
}: {
  offset: number;
  limit: number;
  total: number;
  onChange: (offset: number) => void;
}) {
  const { t } = useTranslation();
  const p = pageInfo(offset, limit, total);
  if (total <= limit && offset === 0) return null;
  return (
    <div className="mt-6 flex items-center justify-between text-sm text-on-surface-variant">
      <span>{t('adminStudents.paginationRange', { from: p.from, to: p.to, total })}</span>
      <div className="flex gap-2">
        <Button size="sm" variant="ghost" disabled={!p.hasPrev} onClick={() => onChange(Math.max(0, offset - limit))}>
          {t('common.back')}
        </Button>
        <span className="self-center text-on-surface">
          {p.page} / {p.pages}
        </span>
        <Button size="sm" variant="ghost" disabled={!p.hasNext} onClick={() => onChange(offset + limit)}>
          {t('adminStudents.nextPage')}
        </Button>
      </div>
    </div>
  );
}
